import { useCallback } from 'react';

import type { WizardContext } from '@swf/core/types/Wizard';

const useHasMitIdDataContext = () =>
  useCallback(
    ({ data: { mitIdResultContext } }: Pick<WizardContext, 'data'>) => !!mitIdResultContext,
    []
  );

export default useHasMitIdDataContext;
